/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MaxDiscount/view.blocks to change it.
import Base from './Base/index'
import React from 'react'
import Value from './Value/index'



/** @type {import('Simple/types.js').View} */
export default function MaxDiscount({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Send/Content/Sidebar/Content/EditRules/MaxDiscount"
  
}) {
  return (<React.Fragment
>
<Value
  viewPath={`${viewPath}/Value`}
/>
<Base
  viewPath={`${viewPath}/Base`}
/>
{children}
</React.Fragment>)
}